export default "__VITE_ASSET__DoVAXAfH__"